import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 640px;
  display: flex;
  flex-direction: column;
  gap: 20px;

  @media (max-width: 1455px) {
    width: 100%;
    padding: 0 0 20px;
  }

  h1 {
    font-weight: 600;
    font-size: 44px;
    line-height: 130%;
    text-align: left;
    color: var(--color-text);
    @media (max-width: 1455px) {
      text-align: center;
    }
  }

  h2 {
    font-size: 26px;
    font-weight: 600;
    line-height: 130%;
    text-align: left;
    color: var(--color-text);
    @media (max-width: 1455px) {
      text-align: center;
      font-size: 24px;
      margin-top: -10px;
    }
  }

  .form-section {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  p {
    font-weight: 400;
    font-size: 18px;
    line-height: 150%;
    color: var(--color-text);
  }

  h4 {
    font-weight: 600;
    font-size: 20px;
    line-height: 130%;
    text-align: left;
    color: var(--color-text);
    span {
      font-weight: 500;
    }
  }

  h5 {
    font-weight: 500;
    font-size: 11px;
    line-height: 100%;
    color: var(--color-text-muted);
  }

  .products {
    display: flex;
    flex-direction: column;
    gap: 20px;
    @media (max-width: 1455px) {
      flex-direction: row;
      padding-bottom: 10px;
      flex-wrap: wrap;
    }
  }

  .check-product-button {
    border: 2px solid var(--color-border);
    text-align: center;
    cursor: pointer;
    display: block;
    background: var(--color-surface);
    padding: 20px 15px;
    border-radius: 20px;
    color: var(--color-text);
    align-content: start;

    font-weight: 700;
    font-size: 14px;
    line-height: 150%;

    &:last-child {
      align-content: center;
    }

    @media (max-width: 1455px) {
      width: calc((100% - 20px) / 2);
      flex-grow: 0;
      flex-shrink: 0;
    }
    svg {
      margin: 0 auto 14px;
    }
    .text-sm {
      padding: 5px 0 0;
      font-weight: 400;
      font-size: 14px;
      line-height: 150%;
    }

    &:hover {
      border: 2px solid var(--color-accent);
    }

    &.active {
      border: 2px solid var(--color-accent);
      background: var(--color-surface-muted);
    }
  }

  textarea {
    color: var(--color-text);
    border: 1px solid var(--color-border);
    box-shadow: none;
    &:hover,
    &:active,
    &:focus {
      border: 1px solid var(--color-accent);
      color: var(--color-text);
    }
    &::placeholder {
      color: var(--color-text-muted);
    }
  }
  @media (max-width: 767px) {
    h1 {
      font-size: 30px;
    }
    .check-product-button {
      width: 100%;
    }
  }
`;
